import React, { useState } from "react";
import { useContext } from "react";
import { Modal, Button } from "rsuite";
import { ModelContext } from "../../contexts/ModelContext";

function SaveAlertModel() {
  const {
    openAskSaveModel,
    setOpenAskSaveModel,
    changePushEdit,
    setBackListPage,
    openSecondModel,
    setOpenSecondModel,
    loading,
    setLoading,
  } = useContext(ModelContext);
  const handleClose = () => {
    setOpenAskSaveModel(false);
    setOpenSecondModel(true);
    setLoading(false)
  };
  const handleCloseAndSendApi = () => {
    changePushEdit();
    setLoading(true);
    setBackListPage(false);
  };
  return (
    <Modal open={openAskSaveModel} role="alertdialog" backdrop="static">
      <Modal.Header closeButton={false}>
        <Modal.Title>
          <div>您的資料有更改</div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          style={{
            padding: "32px 0px",
            whiteSpace: "pre-wrap",
            lineHeight: "24px",
          }}
        >
          您有未存檔的轉診資料，請確認是否要存檔
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          appearance="primary"
          disabled={loading}
          onClick={handleCloseAndSendApi}
        >
          {loading ? "資料傳送中" : "立即存檔"}
        </Button>
        <Button onClick={handleClose} disabled={loading}>放棄修改</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default SaveAlertModel;
